var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-content"},[_c('div',{staticClass:"cover-image"},[_c('b-img',{attrs:{"src":_vm.coverImage,"fluid":""}}),_vm._v(" "),(_vm.liveDj)?_c('img',{staticStyle:{"position":"absolute","top":"0px","left":"0px","height":"100px","width":"auto","opacity":"0.75"},attrs:{"src":require("./assets/img/emp-tweaked-lg.png")}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bba466","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 387
// module chunks = 0